import React from 'react';
import { ConditionalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';
import placeholderSVG from '@redturtle/volto-io-studio/components/Layout/images/placeholder.svg';

/* Style */
import './CardsWithImageAppearance.less';

const CardsWithImageAppearance = ({ item, isEditMode, index, data }) => {
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <div className="cards-appearance">
      <div className="item-wrapper">
        {/* Image */}
        {item?.image ? (
          <div className="image">
            <Image
              alt={item.title}
              title={item.title}
              item={item}
              responsive={true}
            />
          </div>
        ) : (
          <div className="image">
            <Image src={placeholderSVG} responsive={true} />
          </div>
        )}
        <div className="text">
          {/* Titolo */}
          <ConditionalLink
            item={item}
            condition={!isEditMode}
            className={'detail-link'}
          >
            <h3>{item.title ? item.title : item.id}</h3>
          </ConditionalLink>

          {/* Descrizione */}
          {item.description && (
            <p className="slice-description">
              {item.description?.slice(0, 100) + '...'}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default CardsWithImageAppearance;
